export default __webpack_public_path__ + "static/media/review.1df60ec9.svg";